import React, { useEffect } from "react";
import MenuImage from "../../components/MenuImage/MenuImage";
import MenuPdf from "../../components/MenuPdf/MenuPdf";
import BackButton from "../../components/BackButton/BackButton";
import "../IndexPage/IndexPage.css";

function SakePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <BackButton />
      <div className="sakenew-background"></div>
      <div className="card-container">
        <MenuPdf slug="sake" className="pdf-sake" alt="Sake">
          <MenuImage
            width="1500" height="2121"
            className="pdf-sake"
            es="img/sake.webp"
            en="img/sake_en.webp"
            ja="img/sake_ja.webp"
            alt="Sake"
          />
        </MenuPdf>
      </div>
    </div>
  );
}

export default SakePage;
